import { useState, useEffect, forwardRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import { Table } from 'antd';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import apiConfig from '../../config/apiConfig';
import { async } from '@firebase/util';

let startAfterDoc = '';
let backupTransactions = [];
let dialogLocalState = false;

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TransactionsHistoryDialog(props) {
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [transactionsList, setTransactionsList] = useState([]);
  const [dialogState, setdialogState] = useState(false);

  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const columns = [
    {
      title: 'Transaction Hash',
      dataIndex: 'txId',
      key: 'txId',
      render: (text) => {
        return (
          <a
            href={`https://whatsonchain.com/tx/${text}`}
            className="link link-color"
            target="_blank"
            rel="noreferrer"
          >
            {text.slice(0, 20)}...
            <OpenInNewIcon style={{ marginLeft: 5, width: 12, height: 12 }} />
          </a>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'balance_change',
      render: (text) => {
        return (
          <span
            style={{
              color: Number(text) < 0 ? 'red' : 'green',
            }}
          >
            {Number(text) < 0 ? 'Withdrawal' : 'Deposit'}
          </span>
        );
      },
      sorter: (a, b) => Number(a.balance_change) - Number(b.balance_change),
    },
    // {
    //   title: 'Action',
    //   dataIndex: 'protocol',
    //   render: (text) => {
    //     return <span>{text}</span>;
    //   },
    // },
    {
      title: 'Amount (USD)',
      dataIndex: 'balance_change',
      render: (text) => {
        return (
          <span>{((Number(text) / 100000000) * bsvRate).toFixed(10)}</span>
        );
      },
      sorter: (a, b) => Number(a.balance_change) - Number(b.balance_change),
    },
    {
      title: 'Amount (BSV)',
      dataIndex: 'balance_change',
      render: (text) => {
        return <span>{(Number(text) / 100000000).toFixed(8)}</span>;
      },
      sorter: (a, b) =>
        Number(a.balance_change) / 100000000 -
        Number(b.balance_change) / 100000000,
    },

    {
      title: 'from',
      dataIndex: 'from',
      render: (text) => {
        return <span>{text}</span>;
      },
    },
    {
      title: 'to',
      dataIndex: 'to',
      render: (text) => {
        return <span>{text}</span>;
      },
    },

    {
      title: 'Time',
      dataIndex: 'timestamp',
      render: (text) => {
        return <span>{moment(text).format('DD MMM YYYY, HH:mm:ss')}</span>;
      },
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        if (a.timestamp < b.timestamp) return -1;
        if (a.timestamp > b.timestamp) return 1;
        else return 0;
      },
    },

    // {
    //   title: "Address",
    //   dataIndex: "address",
    //   render: (text) => {
    //     return <span>{text}</span>;
    //   },
    // },

    // {
    //   title: "Block Id",
    //   dataIndex: "block_id",
    //   render: (text) => {
    //     return (
    //       <span>
    //         {text && Number(text) && Number(text) > 0 ? text : "unconfirmed"}
    //       </span>
    //     );
    //   },
    //   sorter: (a, b) => Number(a.block_id) - Number(b.block_id),
    // },
  ];
  const { balance } = props;

  useEffect(() => {
    if (dialogState) {
      console.log('calling get trans');
      startAfterDoc = '';
      backupTransactions = [];

      getTransactions();
    }
  }, [dialogState]);

  useEffect(() => {
    if (userDataRedux && props.dialogState) {
      setdialogState(true);
      dialogLocalState = true;
    } else if (!props.dialogState) {
      setdialogState(false);
      setLoading(true);
      setTransactionsList([]);
      dialogLocalState = false;
    }
  }, [userDataRedux, props.dialogState]);

  useEffect(() => {
    return () => {
      startAfterDoc = '';
      backupTransactions = [];
    };
  }, []);

  const getTransactions = async () => {
    if (dialogLocalState) {
      try {
        console.log('get transaction called', dialogLocalState);
        setLoading(true);

        const transData = await apiConfig.get(
          `/v1/history?nextPageToken=${startAfterDoc}`,
          {
            headers: {
              walletID: '00000000-0000-0000-0000-000000000000',
            },
          },
        );

        const { data } = transData;

        if (data?.data?.histories) {
          if (!data?.data?.nextPageTokenId) {
            setHasMore(false);
          }
          startAfterDoc = data?.data?.nextPageTokenId;

          backupTransactions = [
            ...backupTransactions,
            ...data.data.histories.filter((x) => x.protocol === 'BSV'),
          ];

          if (dialogLocalState) {
            setTransactionsList([...backupTransactions]);
          }
          if (data?.data?.nextPageTokenId && backupTransactions.length < 10) {
            getTransactions();
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } catch (err) {
        console.log('err', err.message, err);
        setLoading(false);
      }
    }
  };

  const handleClose = () => {
    props.setdialogState(false);
  };

  return (
    <Dialog
      className="MuiDialog-Transaction"
      open={dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: '100%',
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 999 }}
      maxWidth="lg"
      onClose={handleClose}
    >
      <div>
        <div>
          <DialogContent style={{ padding: 0 }}>
            <InfiniteScroll
              dataLength={transactionsList.length}
              next={getTransactions}
              hasMore={hasMore}
              height={450}
              // loader={
              //   <p style={{ textAlign: 'center' }}>
              //     <b>Loading...</b>
              //   </p>
              // }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  {transactionsList?.length > 0 && !loading && !hasMore && (
                    <b>Yay! You have seen it all</b>
                  )}
                </p>
              }
            >
              <div
                className="dialog-titlebar dialog_borderBottom"
                style={{
                  padding: '15px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  background: '#fafafa',
                }}
              >
                <div className="dialog-title" style={{ fontSize: 20 }}>
                  Transactions
                </div>
                <div style={{ marginLeft: 'auto', marginRight: 10 }}>
                  <button
                    className="text-black text-lg font-light rounded-full outline-none focus:outline-none border border-gray-300"
                    type="button"
                    onClick={handleClose}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              {transactionsList?.length > 0 && (
                <div className="w-full">
                  <Table
                    rowKey="docId"
                    columns={columns}
                    dataSource={transactionsList}
                    pagination={false}
                  />
                </div>
              )}

              {(() => {
                if (transactionsList?.length === 0 && !loading && !hasMore) {
                  return <p className="text-center">0 transactions found</p>;
                }
              })()}

              {loading && (
                <p style={{ textAlign: 'center' }}>
                  <b>Loading...</b>
                </p>
              )}
            </InfiniteScroll>
          </DialogContent>
        </div>
      </div>
    </Dialog>
  );
}
